import { render, staticRenderFns } from "./MeituanDataTab.vue?vue&type=template&id=14878390"
import script from "./MeituanDataTab.vue?vue&type=script&lang=js"
export * from "./MeituanDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports